export default "__VITE_PUBLIC_ASSET__17df79ef__"